import { render } from "./mainUserMenu.vue?vue&type=template&id=513c3e35&scoped=true&ts=true"
import script from "./mainUserMenu.vue?vue&type=script&lang=ts"
export * from "./mainUserMenu.vue?vue&type=script&lang=ts"

import "./mainUserMenu.vue?vue&type=style&index=0&id=513c3e35&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-513c3e35"]])

export default __exports__